module.exports = __webpack_public_path__ + "img/tr-signboard-printed-icon.1fadf6e8.svg";